@if (header) {
  <lib-form-header [tooltipText]="headerTooltip" [translatedHeader]="header" [toggleOpen]="false"></lib-form-header>
}

<div class="row">
  <div class="col-6">
    <div class="form-field-label pb-2">
      <span>{{ lightLabel }}</span>
    </div>
    <div class="photo-upload-container">
      <lib-photo-upload-list
        (filesChange)="lightFilesChange.emit($event)"
        [images]="faviconLight ? [faviconLight] : []"
        [fileTypesString]="fileTypesString"
        [fileNoteKey]="'upload.upload_favicon_note'"
        [showImgNote]="false"
        (mediaRemoved)="lightRemoved.emit()"
        [maxItems]="1"
      ></lib-photo-upload-list>
    </div>
    @if (lightNote) {
      <p class="field-hint">{{ lightNote }}</p>
    }
  </div>
  <div class="col-6">
    <div class="form-field-label pb-2">
      <span>{{ darkLabel }}</span>
    </div>
    <div class="photo-upload-container">
      <lib-photo-upload-list
        (filesChange)="darkFilesChange.emit($event)"
        [images]="faviconDark ? [faviconDark] : []"
        [fileTypesString]="fileTypesString"
        [fileNoteKey]="'upload.upload_favicon_note'"
        [showImgNote]="false"
        (mediaRemoved)="darkRemoved.emit()"
        [maxItems]="1"
      ></lib-photo-upload-list>
    </div>
    @if (darkNote) {
      <p class="field-hint">{{ darkNote }}</p>
    }
  </div>
</div>
